"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfRegistrationService = void 0;
const request_1 = require("../common/request");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
class SelfRegistrationService {
    static validatePassword(password) {
        const commonNetworkService = new nodejs_library_1.CommonNetworkService();
        const body = {
            password: password,
        };
        const request = new request_1.Request(`registrazioni/v1/unsecure/registrazione/verifica-password/`, { body });
        return commonNetworkService.post(request.completeUrl, request.body, request.headers, true);
    }
    static upgradeServiceLevel() {
        const commonNetworkService = new nodejs_library_1.CommonNetworkService();
        const request = new request_1.Request(`registrazioni/v1/registrazione/upgrade-livello-servizio`, undefined);
        return commonNetworkService.put(request.completeUrl, request.body, request.headers);
    }
    static modifyPassword(username, oldPassword, newPassword) {
        const commonNetworkService = new nodejs_library_1.CommonNetworkService();
        const body = {
            nuovaPassword: newPassword,
            vecchiaPassword: oldPassword,
        };
        const request = new request_1.Request(`registrazioni/v1/unsecure/registrazione/${username}/cambio-password/`, { body }, undefined, undefined, "url_pub");
        return commonNetworkService.put(request.completeUrl, request.body, request.headers);
    }
}
exports.SelfRegistrationService = SelfRegistrationService;
